import { canUseDOM } from './canUseDom';

export const integrationTesting = canUseDOM && window.Cypress;
